import { render, staticRenderFns } from "./MandalikaGPReportTab.vue?vue&type=template&id=e76ec718"
import script from "./MandalikaGPReportTab.vue?vue&type=script&lang=js"
export * from "./MandalikaGPReportTab.vue?vue&type=script&lang=js"
import style0 from "./MandalikaGPReportTab.vue?vue&type=style&index=0&id=e76ec718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports